import { DataProvider } from "@refinedev/core";
import restDataProvider from "@refinedev/simple-rest";
import { AxiosInstance } from "axios";
import { axiosInstance } from "providerrs/axiosInstance";
import CONFIG from "app-config/config.json";

const API_URL = CONFIG.UPLOAD_API;

const provider = (axios: AxiosInstance): DataProvider => {
  return {
    ...restDataProvider(API_URL, axios as any),
    create: async ({ variables }) => {
      const headers = {
        'Content-Type': 'multipart/form-data'
      };

      const { data } = await axios.post(API_URL, variables, {
        headers,
      });

      return {
        data
      };
    },
  };
};

export const externalUploadProvider = provider(axiosInstance);
